<template>
  <div class="postavitev-info">
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst">
        <p class="modra-barva-info">
          Žal še nimate povezane naročnine to lahko storite <a href="/Mojprofil/Narocnine">
          <b class="modra-barva-info">
            tukaj
          </b>
        </a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InfoKomponentaNastavitveMojT2NiNarocnin'
}
</script>
<style scoped>
.info-okvir {
  width: 650px;
  height: 85px;
  display: flex;
}

@media only screen and (max-width: 1100px) {
  .info-okvir {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/NastavitveMojT2/InfoKomponentaNastavitveMojT2NiNarocnin.vue